<template>
    <div class="common_switch">{{ val }}</div>
  </template>
  <script>
  export default {
    name: 'CommonSwitch',
    props: {
      cusprop: {},
      row: {}
    },
    computed: {
      val() {
        let val = ''
        for (const key in this.cusprop['mapping']) {
          if (key == this.row[this.cusprop['prop']]) {
            val = this.cusprop['mapping'][key]
          }
        }
        if (this.cusprop['default-value']) {
          return val || this.cusprop['default-value']
        }
        return val || '-'
      }
    }
  }
  </script>
  